<template>
    <div id="detail-barang" class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <b-alert v-if="hasActiveVariance" show variant="warning">
                <i class="fa fa-exclamation-triangle mr-2" />Barang sedang dalam temuan ({{ activeVarianceStatusText }}).
                Approve dan perubahan barang dinonaktifkan sampai temuan selesai.
            </b-alert>
            <b-row>
                <b-col md="6">
                    <div id="delivery-batch" class="font-weight-bold">Kloter Pengiriman</div>
                    {{ $helper.parseDate(item.delivery_date) }} - Cabang {{ item.branch }}
                </b-col>
                <b-col md="6">
                    <div id="item-status" class="font-weight-bold">Status Barang</div>
                    <b-badge :variant="parseStatusVariant(item.status)">
                        {{ parseStatusName(item.status) }}
                    </b-badge>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="6">
                    <div>
                        <div id="item-kind" class="font-weight-bold">Jenis Barang</div>
                        {{ item.kind }}
                    </div>
                    <div>
                        <div id="item-brand" class="font-weight-bold mt-3">Merk Barang</div>
                        {{ item.brand }}
                    </div>
                    <div>
                        <div id="item-type" class="font-weight-bold mt-3">Tipe Barang</div>
                        {{ item.type }}
                    </div>
                    <div>
                        <div id="item-spec" class="font-weight-bold mt-3">Spek dari PGI</div>
                        {{ specName(item.pgi_spec_id) }}
                    </div>
                    <div>
                        <div id="item-year" class="font-weight-bold mt-3">Tahun / Generasi Barang</div>
                        {{ item.year || "-" }}
                    </div>
                </b-col>
                <b-col md="6">
                    <div>
                        <div id="item-invoice" class="font-weight-bold">No. Faktur PGI</div>
                        {{ item.no_faktur }}
                    </div>
                    <div>
                        <div id="item-imei" class="font-weight-bold mt-3">IMEI / SN</div>
                        {{ item.imei_sn }}
                    </div>
                    <div>
                        <div id="item-password" class="font-weight-bold mt-3">Password</div>
                        {{ item.password || "-" }}
                    </div>
                    <div>
                        <div id="item-grade" class="font-weight-bold mt-3">Grade / Kelengkapan dari PGI</div>
                        {{ item.grade_pgi || "-" }} / {{ item.is_batangan_pgi == 1 ? "Batangan" : "Lengkap" }}
                    </div>
                    <div>
                        <div id="item-description" class="font-weight-bold mt-3">Deskripsi Barang</div>
                        <b-form-textarea id="description" v-model="input.description" />
                    </div>
                </b-col>
            </b-row>
            <div v-if="item.status == 1" class="mt-3">
                <b-button id="btn-declare-lost" variant="danger" :disabled="isGradeOnly || hasActiveVariance"
                    :title="isGradeOnly ? 'Hanya dapat melakukan input data Grade' : ''"
                    @click="$bvModal.show('m-request-lost')">
                    <i class="fa fa-times mr-2" />Nyatakan Hilang
                </b-button>
                <b-button v-if="canCreateVariance" id="btn-buat-temuan" variant="danger" class="ml-2"
                    :disabled="hasActiveVariance || isSubmitting" @click="openBuatTemuan">
                    <i class="fa fa-question mr-2" />Buat Temuan
                </b-button>
            </div>
            <hr />
            <div v-if="item.status == 1"><!-- PENDING -->
                <!-- Hide this field input when product is gold -->
                <div v-if="item.category !== 'EMAS'">
                    <h5>Input Data Barang {{ item.brand }}</h5>
                    <small class="form-text text-muted" v-if="isGradeOnly">Status barang dalam kondisi Reset Grade dan data
                        yang
                        dapat di-input terbatas.</small>
                    <b-row class="mt-3">
                        <b-col md="3">
                            <b-form-group id="form-grade" label="Grade Barang">
                                <b-form-select id="form-grade-select" v-model="input.grade" :options="optGrade" />
                            </b-form-group>
                        </b-col>
                        <b-col md="3" v-if="!isGradeOnly">
                            <b-form-group id="form-completeness" label="Kelengkapan Barang">
                                <b-form-select id="form-completeness-select" v-model="input.isBatangan" :options="optBatangan" />
                            </b-form-group>
                        </b-col>
                        <b-col md="3" v-if="!isGradeOnly">
                            <b-form-group id="form-spec" label="Spek Barang">
                                <b-form-select id="form-spec-select" v-model="input.spec" :options="optSpec" />
                                <small v-if="specMismatchWarning" class="text-danger">{{ specMismatchWarning }}</small>
                            </b-form-group>
                        </b-col>
                        <b-col md="3" v-if="!isGradeOnly">
                            <b-form-group id="form-color" label="Warna Barang">
                                <b-form-select id="form-color-select" v-model="input.color" :options="optColor" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="input.grade == 'X'">
                        <b-col md="12">
                            <b-form-group id="form-adj-grade" :label="'Penyesuaian Harga Grade ' + input.grade"
                                description="Gunakan tanda negatif didepan untuk pengurangan harga (Bila positif, maka dianggap penambahan harga)">
                                <b-input-group prepend="Rp.">
                                    <b-input v-model="input.adjGrade" @input="sanitizeAdjGrade" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="!isGradeOnly">
                        <!-- <b-col md="6" v-if="optAccessories.length != 0">
                            <b-form-group label="Accessories yang Tidak Ada">
                                <multiselect v-model="input.missingAcc" :multiple="true" label="name" track-by="id"
                                    :internal-search="true" deselect-label="" select-label="" :options="optAccessories"
                                    :close-on-select="false" @input="test" />
                            </b-form-group>
                        </b-col>
                        <b-col md="6" v-if="optAccessories.length != 0">
                            <b-form-group label="Accessories yang Tidak Ori">
                                <multiselect v-model="input.nonOriAcc" :multiple="true" label="name" track-by="id"
                                    :internal-search="true" deselect-label="" select-label="" :options="optAccessories"
                                    :close-on-select="false" />
                            </b-form-group>
                        </b-col> -->

                        <!-- ? hide this for now, enhance adjustment calculation -->
                        <b-col md="12" class="mb-4" style="display: none;">
                            <b-table id="table-adjustments" bordered hover show-empty no-local-sorting :items="adjustments" :fields="fieldsAdjust"
                                responsive class="mt-4 mb-1">
                                <template v-slot:empty>
                                    Tidak ada adjustment.
                                </template>
                                <template v-slot:cell(category)="row">
                                    <!-- <b-form-input v-model="row.item.name" maxlength="50" /> -->
                                    <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                                    <!-- <b-form-select v-model="row.item.adjustmentSelect" :options="optAdjustments" @change="onChangeAdjustmentSelect($event, row.index)" /> -->
                                    <!-- <b-form-select v-model="row.item.category" :options="optCategory" @change="onChangeRowCategory(row.index)"
                                    :disabled="(activeItem.status == '3' && !activeItem.fixing_adjustment)"/> -->
                                    <div>
                                        {{ row.item.category }}
                                    </div>
                                </template>
                                <template v-slot:cell(name)="row">
                                    <!-- <b-form-input v-model="row.item.name" maxlength="50" /> -->
                                    <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                                    <!-- <b-form-select v-model="row.item.adjustmentSelect" :options="optAdjustments" @change="onChangeAdjustmentSelect($event, row.index)" /> -->
                                    <!-- <b-form-select v-model="row.item.adjustmentSelect" :options="row.item.optAdjustments" @change="changeAdjustment" :disabled="(activeItem.status == '3' && !activeItem.fixing_adjustment)"/>
                                    <small class="text-muted" v-if="row.item.adjustmentSelect === null || row.item.adjustmentSelect.id == null">{{row.item.name_placeholder}}</small> -->
                                    <div>
                                        {{ row.item.name }}
                                    </div>
                                </template>
                                <template v-slot:cell(adjustment)="row">
                                    <b-input-group prepend="Rp.">
                                        <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                                        <!-- <b-form-input v-model="row.item.adjustment" @input="sanitize(row.item)" disabled></b-form-input> -->
                                        <!-- <b-form-input v-model="row.item.adjustment" @input="sanitize(row.item)" :disabled="(row.item.adjustmentPercentage != '' && row.item.adjustmentPercentage != null) || activeItem.status == '3'" ></b-form-input> -->
                                        <b-form-input id="form-adjustment-input" v-model="row.item.adjustment" @input="sanitize(row.item)"
                                            disabled></b-form-input>
                                    </b-input-group>
                                </template>
                                <template v-slot:cell(adjustmentPercent)="row">
                                    <b-input-group append="%">
                                        <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                                        <!-- <b-form-input v-model="row.item.adjustmentPercentage" disabled></b-form-input> -->
                                        <!-- <b-form-input v-model="row.item.adjustmentPercentage" @input="changeAdjustment" :disabled="(row.item.adjustment != '' && row.item.adjustment != null) || activeItem.status == '3'"></b-form-input> -->
                                        <b-form-input id="form-adjustment-percent-input" v-model="row.item.adjustmentPercentage"
                                            disabled></b-form-input>
                                    </b-input-group>
                                </template>
                                <template v-slot:cell(action)="row">
                                    <div class="d-flex">

                                        <b-button id="btn-delete-row" variant="danger" size="sm" class="ml-2" v-b-tooltip.hover.top
                                            title="Hapus" @click="deleteRow(row.index)">
                                            <i class="fa fa-fw fa-times" />
                                        </b-button>
                                    </div>
                                </template>
                            </b-table>
                            <span class="text-muted small mt-1">Biarkan tabel kosong apabila tidak ada adjustment
                                harga</span>
                        </b-col>
                        <!-- <b-col md="4"> -->
                        <!-- <b-form-group label="Catatan Barang (opsional)">
                                <b-input v-model="input.note" maxlength="200" />
                            </b-form-group> -->
                        <!-- <b-form-group label="Kategori Kerusakan">
                                <multiselect v-model="input.category"
                                    label="name"
                                    track-by="id"
                                    :internal-search="true"
                                    deselect-label=""
                                    select-label=""
                                    :options="optCategory"
                                     @input="onChangeCategory"
                                >
                                </multiselect>
                            </b-form-group>
                        </b-col>
                        <b-col md="8"> -->
                        <!-- <b-form-group label="Catatan Barang (opsional)">
                                <b-input v-model="input.note" maxlength="200" />
                            </b-form-group> -->
                        <!-- <b-form-group label="Adjustment Kerusakan">
                                <multiselect v-model="input.adjustments"
                                    label="name"
                                    track-by="id"
                                    :internal-search="true"
                                    deselect-label=""
                                    select-label=""
                                    :close-on-select="false"
                                    :options="optAdjustments"
                                    :disabled="$helper.isBlank(input.category) || optAdjustments.length <= 0"
                                    multiple
                                >
                                    diubah sementara supaya adjustment harga bisa diinput manual dulu
                                    <template slot="option" slot-scope="props">
                                        <div class="option__desc">
                                            <span class="option__title">{{ props.option.label }}</span>
                                            <span class="option__small text-muted"> ({{ props.option.category }})</span>
                                        </div>
                                    </template>
                                </multiselect>
                            </b-form-group>
                        </b-col> -->
                        <!-- <b-col md="12">
                            <b-form-group label="Upload Foto Fisik (opsional, maks. 10 gambar)">
                                <b-form-file multiple v-model="input.photos" accept="image/jpeg, image/png" />
                                <span class="text-muted small">Jumlah foto fisik : {{ item.photo_count }}</span>
                            </b-form-group>
                        </b-col> -->
                        <!-- <b-col md="12">
                            <b-form-group label="Penyesuaian Harga Lainnya" description="Biarkan 0 apabila tidak ada. Gunakan tanda negatif didepan untuk pengurangan harga (Bila positif, maka dianggap penambahan harga)">
                                <b-input-group prepend="Rp.">
                                    <b-input v-model="input.adjOther" @input="sanitizeAdjOther" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-form-group label="Catatan Penyesuaian Harga Lainnya" description="Wajib diisi apabila penyesuaian harga lainnya tidak sama dengan nol">
                                <b-input v-model="input.adjOtherNote" maxlength="200" />
                            </b-form-group>
                        </b-col> -->
                    </b-row>
                </div>
                <b-row>
                    <b-col md="12" class="text-right">
                        <div style="display: flex; justify-content: end;">
                            <!-- ? hide this for now, enhance adjustment calculation -->
                            <!-- <div>
                                <b-button id="submit-barang" variant="dark" :disabled="isSubmitting" @click="openModalAdjustment">
                                    Tambah Adjustment
                                </b-button>
                            </div> -->
                            <div>
                                <b-button id="btn-approve-grade" variant="success" :disabled="isSubmitting || hasActiveVariance" @click="promptSubmitGrade"
                                    v-if="isGradeOnly">
                                    {{ isSubmitting ? "Menyimpan..." : "Approve Perubahan Grade" }}
                                </b-button>
                                <b-button id="btn-approve-item" variant="success" :disabled="isSubmitting || hasActiveVariance" @click="promptSubmit" v-if="!isGradeOnly">
                                    {{ isSubmitting ? "Menyimpan..." : "Approve Barang" }}
                                </b-button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div v-else-if="item.status == 5"><!-- HILANG -->
                <div>
                    Dinyatakan hilang oleh <span class="font-weight-bold">{{ item.approved_by }}</span> pada {{
            $helper.parseDate(item.approved_at) }}, {{ $helper.parseHourMinute(item.approved_at) }} WIB
                </div>
            </div>
            <div v-else><!-- APPROVED, LAINNYA -->
                <h5 class="mb-0">Input Data Barang</h5>
                <div class="text-muted">
                    Approval dilakukan oleh <span class="font-weight-bold">{{ item.approved_by }}</span> pada {{
            $helper.parseDate(item.approved_at) }}, {{ $helper.parseHourMinute(item.approved_at) }} WIB
                </div>
                <b-row class="mt-3">
                    <b-col md="6">
                        <div class="font-weight-bold">Grade</div>
                        {{ item.grade }}
                        <div class="font-weight-bold mt-3">Kelengkapan</div>
                        {{ item.is_batangan == true ? "Batangan" : "Lengkap" }}
                        <div class="font-weight-bold mt-3">Spek</div>
                        {{ item.spec }}
                        <div class="font-weight-bold mt-3">Lokasi Penyimpanan</div>
                        {{ item.warehouse || "-" }}
                    </b-col>
                    <b-col md="6">
                        <div class="font-weight-bold">Aksesoris yang Tidak Ada</div>
                        {{ item.missing_accessories || "-" }}
                        <div class="font-weight-bold mt-3">Aksesoris yang Tidak Ori</div>
                        {{ item.not_ori_accessories || "-" }}
                    </b-col>
                </b-row>
            </div>
        </div>
        <b-modal id="m-request-lost" title="Nyatakan Barang Hilang" centered hide-footer no-close-on-backdrop
            no-close-on-esc>
            <b-form-group id="form-lost-note" label="Keterangan Hilang">
                <b-input id="form-lost-note-input" v-model="noteLost" maxlength="200" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button id="btn-declare-lost-confirm" variant="primary" :disabled="isSubmitting" @click="promptItemLost">
                    {{ isSubmitting ? "Menyimpan..." : "Nyatakan Hilang" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-barcode" title="Cetak Barcode" centered no-close-on-backdrop no-close-on-esc hide-footer
            hide-header-close>
            Silahkan cetak barcode dibawah ini. Mohon pastikan barcode tercetak dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe id="barcode-frame" :src="getBarcodeLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="12" class="text-right">
                        <b-button id="btn-finish-approval" variant="primary" @click="finishApproval">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal id="m-add-adjustments" title="Tambah Adjustment" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Kategori Kerusakan">
                <b-form-select v-model="addAdj.category" :options="optCategory" @input="onChangeAdjCategory" />
            </b-form-group>
            <b-form-group label="Keterangan">
                  <b-form-select
                    v-model="addAdj.name"
                    :options="addAdj.optAdjustments"
                    :disabled="$helper.isBlank(addAdj.category) || addAdj.optAdjustments.length <= 0"
                    @change="onSelectAdjustment"
                />
            </b-form-group>
            <b-form-group label="Adjustment Harga (Nominal)">
                <b-input-group prepend="Rp.">
                    <b-form-input v-model="addAdj.adjustment" @input="sanitize(addAdj)"
                        :disabled="$helper.isBlank(addAdj.name) || addAdj.hasAdjustmentPrice"
                        maxlength="50" />
                </b-input-group>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmAddAdjustment">
                    {{ isSubmitting ? "Menambah..." : "Tambah" }}
                </b-button>
            </div>
        </b-modal>

        <ModalDataPerubahan context="create" :inventory-id="inventoryId" :no-faktur="item.no_faktur"
            :defaults="temuanDefaults" @saved="onTemuanCreated" />
    </div>
</template>

<script>

import { groupByDamageType } from '@/shared/damage-types'
import EnumPermission from '@/shared/enum-permissions'
import { getVarianceStatusBadge, VARIANCE_STATUS } from '@/shared/inventory-variance'
import ModalDataPerubahan from '../temuan-inventory/ModalDataPerubahan.vue'

const GRADES = ["S", "A", "B", "C", "D", "E", "X"]

export default {
    name: 'barang-masuk-detail-barang',
    components: { ModalDataPerubahan },
    props: {
        inventoryId: { type: Number, required: true }
    },
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,

            item: {},
            input: {
                grade: "A",
                adjGrade: "",
                spec: 1,
                warehouse: 0,
                isBatangan: false,
                missingAcc: [],
                nonOriAcc: [],
                // note: "",
                photos: [],
                adjOther: "0",
                adjOtherNote: "",
                adjustments: [],
                category: "",
                color: -1,
                description: ""
            },

            addAdj: {
                category: null,
                name: null,
                optAdjustments: [],
                adjustment: "",
                hasAdjustmentPrice: false,
                selectedCategoryAdjustments: [],
            },

            noteLost: "",
            temuanDefaults: null,

            optGrade: GRADES,
            optSpec: [],
            optWarehouse: [],
            optBatangan: [
                { value: false, text: "Lengkap" },
                { value: true, text: "Batangan" }
            ],
            optAccessories: [],

            optColor: [],

            barcodeLink: "",
            barcodeLinkDamage: "",

            barcodeType: 'barcode',
            barcodeToggleCooldown: false,

            adjustments: [],
            optAdjustments: [],
            optCategory: [],

            fieldsAdjust: [
                { key: "category", label: "Kategori", sortable: false, thClass: 'adjust-column-min' },
                { key: "name", label: "Keterangan", sortable: false, thClass: 'adjust-column-min' },
                { key: "adjustment", label: "Potongan / Tambahan Harga (Nominal)", sortable: false },
                { key: "action", label: "Aksi" },
            ],

        }
    },
    methods: {

        init() {

            this.initStatus = 0
            this.optSpec = [];
            this.optWarehouse = [];
            this.optAccessories = [];
            this.optColor = [{ value: -1, text: "Pilih Warna" }];

            this.$axios.get("delivery/inventory/" + this.inventoryId).then(res => {
                this.item = res.data.data

                this.item.available_specs.forEach(it => {
                    this.optSpec.push({ value: it.id, text: it.name })
                })

                this.input.spec = this.item.pgi_spec_id ? this.item.pgi_spec_id : this.optSpec[0].value

                this.item.available_warehouses.forEach(it => {
                    this.optWarehouse.push({ value: it.id, text: it.name })
                })

                this.item.available_accessories.forEach(it => {
                    this.optAccessories.push({ id: it.id, name: it.name })
                })

                this.input.isBatangan = this.item.is_batangan_pgi == true

                this.input.color = this.item.item_color_id

                this.optGrade = this.item.has_grade_s ? GRADES : GRADES.filter(g => g != "S")
                if (this.isGradeOnly && this.optGrade.includes(this.item.reset_grade_target)) {
                    this.input.grade = this.item.reset_grade_target
                }
                if (!this.optGrade.includes(this.input.grade)) {
                    this.input.grade = "A"
                }

                // let getCategories = this.$axios.get("category/selection?item_kind_id=" + this.item.kind_id).then(res => {
                //     this.optCategory = res.data.data.map(item => {
                //         return {
                //             value: item.id,
                //             text: item.name
                //         }
                //     })
                // })

                let getColors = this.$axios.get("master/color/selection").then(res => {
                    for (let i = 0; i < res.data.data.length; i++) {
                        this.optColor.push({
                            value: res.data.data[i].id,
                            text: res.data.data[i].name
                        })
                    }
                })


                let getAdjustments = this.$axios.get("category/selection?item_kind_id=" + this.item.kind_id).then(res => {
                    this.optCategory = res.data.data.map(item => {
                        return {
                            value: item.id,
                            text: item.name
                        }
                    })
                    let param = "?id=" + this.item.id
                    this.$axios.get("inventory/get-invoice-adjustments" + param).then(res => {
                        this.adjustments = res.data.data.map(item => {
                            let adjustmentObj = {
                                adjustment_id: item.adjustments_id,
                                name: item.adjustments_name,
                                adjustment: item.adjustment_percentage ? "" : item.adjustment,
                                adjustmentPercentage: item.adjustment_percentage,
                                category: item.category_name,
                            };
                            return adjustmentObj;
                        });

                        for (let i = 0; i < this.adjustments.length; i++) {
                            this.sanitize(this.adjustments[i]);
                        }
                    })
                        .catch(error => this.$helper.parseError(this, error))
                        .finally(() => this.isSubmitting = false)
                })

                Promise.all([getAdjustments, getColors]).then(res => {
                    this.initStatus = 1
                }).catch(error => {
                    this.$helper.parseError(this, error)
                    this.initStatus = -1
                })
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.initStatus = -1
                })

        },

        promptItemLost() {

            if (this.noteLost == "") {
                return this.$helper.toastError(this, "Mohon mengisi keterangan!")
            }

            let isConfirmed = confirm("Nyatakan barang ini hilang?")
            if (!isConfirmed) return

            this.isSubmitting = true
            let payload = {
                id: this.inventoryId,
                note: this.noteLost
            }

            this.$axios.post("delivery/lost", payload).then(res => {
                this.$emit("lost")
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        getBarcodeLink() {
            if (this.barcodeType == 'barcode') {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}`
            }
            else {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLinkDamage}`
            }
        },

        toggleBarcodeType() {
            this.barcodeToggleCooldown = true
            if (this.barcodeType == 'barcode') this.barcodeType = 'damage'
            else this.barcodeType = 'barcode'
            setTimeout(function () {
                this.barcodeToggleCooldown = false
            }.bind(this), 2000);
        },

        promptSubmit() {

            let confirmable = true
            let isAdjustmentEmpty = false

            // check if product is gold
            const isGoldProduct = this.item.category === 'EMAS';

            // if (this.input.photos.length + this.item.photo_count > 10) {
            //     confirmable = false
            //     return this.$helper.toastError(this, "Upload foto maksimum 10 foto!")
            // }

            let gradesWithManualAdjustment = ["X"]
            if (gradesWithManualAdjustment.includes(this.input.grade) && this.$helper.isBlank(this.input.adjGrade)) {
                confirmable = false
                return this.$helper.toastError(this, "Mohon mengisi penyesuaian harga grade untuk Grade X!")
            }

            if (this.specMismatchWarning) {
                return this.$helper.toastError(this, this.specMismatchWarning)
            }

            if (this.$helper.isBlank(this.input.adjOther)) {
                confirmable = false
                return this.$helper.toastError(this, "Penyesuaian harga lainnya tidak boleh kosong. Isi dengan angka nol apabila tidak ada penyesuaian lainnya!")
            }

            if (this.input.adjOther != "0" && this.$helper.isBlank(this.input.adjOtherNote)) {
                confirmable = false
                return this.$helper.toastError(this, "Mohon mengisi catatan penyesuaian harga lainnya!")
            }

            if (this.input.color == -1 && this.optColor.length > 1 ||this.input.color == null || this.input.color == 0 || this.input.color == "") {
                confirmable = false
                return this.$helper.toastError(this, "Mohon mengisi pilihan warna barang!")
            }

            if (this.input.color == -1) {
                this.input.color = null
            }

            if (confirmable) {
                let confirmed = confirm("Lakukan approval dengan data input ini?")
                if (confirmed) {

                    let payload = new FormData()
                    // this.input.photos.forEach(it => {
                    //     payload.append("photos[]", it)
                    // })

                    let jsonData = {
                        id: this.inventoryId,
                        grade: isGoldProduct ? "A" : this.input.grade, // force set value when product is gold;
                        spec: isGoldProduct ? 2 : this.input.spec,
                        colorId: isGoldProduct ? 11 : this.input.color,
                        isBatangan: isGoldProduct ? false : this.input.isBatangan,
                        missingAcc: this.input.missingAcc,
                        nonOriAcc: this.input.nonOriAcc,
                        // note: this.input.note,
                        adjGrade: this.$helper.toNumber(this.input.adjGrade),
                        adjOther: this.$helper.toNumber(this.input.adjOther),
                        adjOtherNote: this.input.adjOtherNote,
                        description: this.input.description,
                        // adjInvoice: this.input.adjustments.map(item => {
                        //     return {
                        //         adjustment_id: item.id,
                        //         name: item.name,
                        //         adjustment: item.adjustment,
                        //         adjustmentPercentage: item.adjustment_percentage
                        //     }
                        // })
                    }

                    if (isAdjustmentEmpty) {
                        jsonData["adjInvoice"] = []
                    }
                    else {
                        jsonData["adjInvoice"] = this.adjustments.map(it => ({
                            name: it.name,
                            adjustment: this.$helper.isBlank(it.adjustmentPercentage)
                                ? this.$helper.toNumber(it.adjustment)
                                : null,
                            adjustmentPercentage: !this.$helper.isBlank(it.adjustmentPercentage)
                                ? Number(parseFloat(it.adjustmentPercentage.replace(',', '.').replace(' ', ''))).toFixed(2)
                                : null,
                            adjustment_id: it.adjustmentId
                        }))
                    }

                    // payload.append("data", JSON.stringify(jsonData))

                    this.isSubmitting = true
                    this.$axios.post("delivery/approve", jsonData).then(res => {
                        this.barcodeLink = res.data.data.link
                        this.barcodeLinkDamage = res.data.data.linkDamage
                        this.$bvModal.show('m-barcode')
                    })
                        .catch(error => this.$helper.parseError(this, error))
                        .finally(() => this.isSubmitting = false)

                }
            }




        },

        promptSubmitGrade() {

            let gradesWithManualAdjustment = ["X"]
            if (gradesWithManualAdjustment.includes(this.input.grade) && this.$helper.isBlank(this.input.adjGrade)) {
                return this.$helper.toastError(this, "Mohon mengisi penyesuaian harga grade untuk Grade X!")
            }

            let confirmed = confirm("Lakukan approval dengan data input ini?")
            if (confirmed) {

                let payload = new FormData()

                let jsonData = {
                    id: this.inventoryId,
                    grade: this.input.grade,
                    adjGrade: this.$helper.toNumber(this.input.adjGrade)
                }

                payload.append("data", JSON.stringify(jsonData))

                this.isSubmitting = true
                this.$axios.post("delivery/approve-grade", payload).then(res => {
                    this.barcodeLink = res.data.data.link
                    this.barcodeLinkDamage = res.data.data.linkDamage
                    this.$bvModal.show('m-barcode')
                })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => this.isSubmitting = false)

            }

        },

        finishApproval() {
            this.$bvModal.hide('m-barcode')
            this.$emit("approved")
        },

        openBuatTemuan() {
            this.isSubmitting = true
            this.$axios.get(`inventory-variances/prefill/${this.inventoryId}?origin=APPROVAL`).then(res => {
                this.temuanDefaults = res.data.data
                this.$bvModal.show("m-data-perubahan-temuan-inventory")
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },

        onTemuanCreated(data) {
            this.$set(this.item, "active_variance_id", data.id)
            this.$set(this.item, "active_variance_status", data.status || VARIANCE_STATUS.PENDING_AUDIT)
        },

        parseStatusVariant(status) {

            switch (status) {
                case 1: return "warning"
                case 2: return "success"
                case 5: return "danger"
                default: return "light"
            }

        },

        parseStatusName(status) {

            switch (status) {
                case 1: return "PENDING"
                case 2: return "APPROVED"
                case 5: return "HILANG"
                default: return "LAINNYA"
            }

        },

        sanitizeAdjGrade() {
            let cleaned = String(this.input.adjGrade).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.input.adjGrade = res
        },

        sanitizeAdjOther() {
            let cleaned = String(this.input.adjOther).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.input.adjOther = res
        },

        // onChangeCategory(){
        //     this.optAdjustments = []
        //     if(!this.$helper.isBlank(this.input.category)){
        //         let param = "?item_kind_id=" + this.item.kind_id
        //         param += "&category_id=" + this.input.category.id
        //         this.isSubmitting = true
        //         this.$axios.get("adjustment/selection-category" + param).then(res => {
        //             this.optAdjustments = res.data.data.map(item => {
        //                 return {
        //                     id: item.id,
        //                     name: this.input.category.name + ' - ' + item.name,
        //                     label: item.name,
        //                     category: this.input.category.name
        //                 }
        //             })
        //             this.isSubmitting = false
        //         })
        //     }
        // },


        sanitize(item) {
            let cleaned = String(item.adjustment).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            item.adjustment = res
        },
        addRow() {
            this.adjustments.push({ name: "", category: "", adjustmentSelect: "", adjustment: "", adjustmentPercentage: "", optAdjustments: [] })
        },
        deleteRow(index) {
            this.adjustments.splice(index, 1)
        },
        onChangeRowCategory(index) {
            this.adjustments[index].name = ""
            this.adjustments[index].adjustmentSelect = null
            this.adjustments[index].optAdjustments = []
            if (!this.$helper.isBlank(this.adjustments[index].category)) {
                let param = "?item_kind_id=" + this.item.kind_id
                param += "&category_id=" + this.adjustments[index].category
                this.isSubmitting = true
                this.$axios.get("adjustment/selection-category" + param).then(res => {
                    this.adjustments[index].optAdjustments = groupByDamageType(res.data.data.map(item => {
                        return {
                            value: {
                                id: item.id,
                                name: item.name,
                                adjustment: item.adjustment,
                                adjustment_percentages: item.adjustment_percentages,
                            },
                            text: item.name,
                            damage_type: item.damage_type
                        }
                    }), o => o.damage_type)
                    this.isSubmitting = false
                })
            }
        },

        prepareAddAdjustment() {
            console.log(this.activeItem.fixing_adjustment)
            this.addAdj.optKind = [
                { value: this.activeItem.kind_id, text: this.activeItem.kind }
            ]
            this.addAdj.kind = this.activeItem.kind_id
            this.addAdj.category = null
            this.addAdj.optAdjustments = []
            this.addAdj.name = null
            if (this.activeItem.fixing_adjustment) {
                this.addAdj.adjustment = "0"
                this.addAdj.adjustmentPercentage = ""
            } else {
                this.addAdj.adjustment = ""
                this.addAdj.adjustmentPercentage = ""
            }
            this.$bvModal.show("m-add-adjustments")
        },


        changeAdjustment() {
            this.isChangeAdjustment = true
        },

        onChangeAdjCategory() {
            this.addAdj.name = null
            this.addAdj.optAdjustments = []
            if (!this.$helper.isBlank(this.addAdj.category)) {
                let param = "?item_kind_id=" + this.item.kind_id
                param += "&category_id=" + this.addAdj.category
                this.isSubmitting = true
                this.$axios.get("adjustment/selection-category" + param).then(res => {
                    this.addAdj.optAdjustments = groupByDamageType(res.data.data.map(item => {
                        return {
                            value: item.id,
                            text: item.name,
                            damage_type: item.damage_type
                        }
                    }), o => o.damage_type)
                    this.addAdj.selectedCategoryAdjustments = res.data.data;
                    this.isSubmitting = false
                })
            }
        },

        // addRow() {
        //     this.invoiceAdjustments.push({ name: "", adjustmentSelect: "", adjustment: "", adjustmentPercentage: "" })
        // },

        confirmAdd(id) {

            let confirmable = true

            for (var i = 0; i < this.invoiceAdjustments.length; i++) {

                let adj = this.invoiceAdjustments[i]

                if (this.$helper.isBlank(adj.adjustment) && this.$helper.isBlank(adj.adjustmentPercentage)) {
                    confirmable = false
                    return this.$helper.toastError(this, "Terdapat data adjustment yang kosong, mohon dilengkapi!")
                }

            }

            if (confirmable) {
                let payload = new FormData()
                let jsonData = {
                    adjInvoice: this.invoiceAdjustments.map(it => {
                        if (this.$helper.isBlank(it.adjustmentPercentage)) {
                            return {
                                name: it.adjustmentSelect.name,
                                adjustment: this.$helper.toNumber(it.adjustment),
                                adjustmentPercentage: null,
                                adjustment_id: it.adjustmentSelect.id
                            }
                        }
                        else {
                            return {
                                name: it.adjustmentSelect.name,
                                adjustment: parseInt(this.activeItem.final_price * parseFloat(it.adjustmentPercentage.replace(',', '.').replace(' ', '')) / 100),
                                adjustmentPercentage: Number(parseFloat(it.adjustmentPercentage.replace(',', '.').replace(' ', ''))).toFixed(2),
                                adjustment_id: it.adjustmentSelect.id
                            }
                        }
                    })
                }

                payload.append("data", JSON.stringify(jsonData))
                payload.append("id", id)
                payload.append("changed", this.isChangeAdjustment)

                this.isSubmitting = true
                this.$axios.post("inventory/update-invoice-adjustments", payload).then(res => {
                    this.$helper.toastSuccess(this, "Update Adjustment Berhasil!")
                    this.$bvModal.hide("m-item-to-adjust")
                    this.getItems(this.currentPage)
                })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => this.isSubmitting = false)
            }

        },


        sanitizeString(str) {
            let cleaned = String(str).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            return res
        },

        specName(id) {
            switch (id) {
                case 1: return "ORI"
                case 2: return "RESMI"
                case 3: return "RR"
                case 5: return "LN"
                default: return "-"
            }
        },
        onSelectAdjustment(e,) {
            const selected = this.addAdj.selectedCategoryAdjustments.find(
                item => item.id === e
            ).adjustment_percentages;

            if (!selected) {
                this.addAdj.adjustment = "";
                this.addAdj.hasAdjustmentPrice = false;
                return;
            }

            const adjustmentObj = selected.find(
                range => this.item.base_price >= range.from && this.item.base_price <= range.to
            );

            const adjustmentPrice = adjustmentObj ? adjustmentObj.nominal : 0;

            if (adjustmentPrice === 0) {
                this.addAdj.adjustment = "";
                this.addAdj.hasAdjustmentPrice = false;
                return;
            }

            let cleaned = String(adjustmentPrice).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")

            this.addAdj.adjustment = res;
            this.addAdj.hasAdjustmentPrice = true;
        },
        openModalAdjustment() {
            this.$bvModal.show("m-add-adjustments")
        },
        confirmAddAdjustment() {

            if (this.$helper.isBlank(this.addAdj.category)) {
                return this.$helper.toastError(this, "Mohon memilih kategori kerusakan!")
            }

            if (this.$helper.isBlank(this.addAdj.name)) {
                return this.$helper.toastError(this, "Mohon memilih keterangan!")
            }

            if (this.$helper.isBlank(this.addAdj.adjustment) || this.addAdj.adjustment === "0") {
                return this.$helper.toastError(this, "Mohon mengisi harga adjustment!")
            }

            this.adjustments.push({
               name: (function() {
                   const adj = this.addAdj.optAdjustments.flatMap(g => g.options).find(adj => adj.value === this.addAdj.name);
                   return adj ? adj.text : "";
               }).call(this),
               category: (function() {
                   const cat = this.optCategory.find(cat => cat.value === this.addAdj.category);
                   return cat ? cat.text : "";
               }).call(this),
               adjustment: this.addAdj.adjustment,
               adjustmentId: this.addAdj.name,
            });

            this.addAdj = {
                category: null,
                name: null,
                optAdjustments: [],
                adjustment: "",
                hasAdjustmentPrice: false,
                selectedCategoryAdjustments: [],
            };

            this.$bvModal.hide("m-add-adjustments");
        }
    },

    computed: {
        isGradeOnly() {
            return this.item.pending_type == 1
        },
        specMismatchWarning() {
            if (this.item.category === 'EMAS' || !this.item.pgi_spec_id) return null
            if (Number(this.input.spec) === Number(this.item.pgi_spec_id)) return null
            return "Spek tidak sesuai dengan data PGI, silakan buat temuan!"
        },
        hasActiveVariance() {
            return !!this.item.active_variance_id
        },
        activeVarianceStatusText() {
            return getVarianceStatusBadge(this.item.active_variance_status).text
        },
        canCreateVariance() {
            return this.item.category !== 'EMAS' && (
                this.$helper.isAllowed(EnumPermission.INVENTORY_VARIANCE.toString()) ||
                this.$helper.isAllowed(EnumPermission.APPROVE_BARANG.toString())
            )
        }
    },

    created() {
        this.init()
    }
}
</script>

<style scoped>
.multiselect__option--highlight .option__small {
    color: #d8dbde !important;
}

.multiselect__option--selected .option__small {
    color: #ccccee !important;
}

.multiselect__option--highlight.multiselect__option--selected .option__small {
    color: #ccccee !important;
}

/deep/ .adjust-column-min {
    min-width: 200px;
}

.media-container {
    height: 0;
    padding-top: 56.25%;
    position: relative;
}

.media-preview {
    max-height: 100%;
    max-width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    left: 50%;
    transform: translateX(-50%);
}

:not(:root):-webkit-full-screen {
    object-fit: contain !important;
}

.media-scroll {
    margin-top: 10px;
    height: 70px;
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    background-color: #dee2e6;
    white-space: nowrap;
}

.media-scroll-content {
    display: inline-block !important;
    height: 100%;
    width: 20%;
}

.media-scroll-preview.active {
    border: 5px solid #65c2e4;
}

.media-scroll-preview:hover {
    opacity: 0.5;
}

.media-scroll-preview {
    height: 100%;
    width: 100%;
    border: 5px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    cursor: pointer;
}

.border-responsive {
    margin-top: 10px;
    border-top: 1px solid #c8ced3;
}

.media-disclaimer {
    text-align: justify;
    text-justify: inter-word;
}

@media only screen and (min-width: 576px) {
    .media-scroll {
        height: 100px;
    }
}

@media only screen and (min-width: 992px) {
    .border-responsive {
        margin-top: 0px;
        border-top: none;
        border-left: 1px solid #c8ced3;
    }
}

@media only screen and (min-width: 1200px) {
    .media-scroll {
        height: 150px;
    }
}
</style>
